import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ITableColumnHeader } from 'src/app/models/table-column-header';
import { ApiService } from 'src/app/providers/api.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-all-support-request',
  templateUrl: './all-support-request.component.html',
  styleUrls: ['./all-support-request.component.scss']
})
export class AllSupportRequestComponent implements OnInit, OnDestroy {
  messageList: any[] = [];
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: "name",
      columnProperty: "senderName"
    },
    {
      columnName: "subject",
      columnProperty: "subject"
    },
    {
      columnName: "message",
      columnProperty: "message"
    },
    {
      columnName: "status",
      columnProperty: "messageStat"
    },

  ];
  private _apiSubscription: Subscription;

  constructor(private _apiService: ApiService) { 
    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
      if(resData.responseType === SM_CONSTANTS.GET_CONTACT_MESSAGES_RESULT){
        console.log(resData);
        this.messageList = resData.result ? resData.result : [];
        this.messageList.forEach((element:any) => {
          if(element.messageStatus == '1'){
            element.messageStat = 'No action taken'
          }
          if(element.messageStatus == '2'){
            element.messageStat = 'Replied'
          }
          if(element.messageStatus == '3'){
            element.messageStat = 'Resolved'
          }
          if(element.messageStatus == '4'){
            element.messageStat = 'Opened'
          }
        })
      }
      if(resData.responseType === SM_CONSTANTS.ADD_CONTACT_MESSAGES_RESULT){
        console.log(resData);
        this.ngOnInit()
        
      }
    });
  }

  ngOnInit(): void {
    this._apiService.getContactMessages();
  }

  markReplied(hashId: any){
    let data = {
      
        hashId: hashId,
        status: 2
    
    }

    this._apiService.addContactMessages(data)
  }


  markResolved(hashId: any){
    let data = {
      
      hashId: hashId,
      status: 3
  
  }
  this._apiService.addContactMessages(data)
  }


  markOpened(hashId: any){
    let data = {
      
      hashId: hashId,
      status: 4
  
  }
  this._apiService.addContactMessages(data)  
}


  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }
}
